import React from 'react';
import { motion } from 'framer-motion';
import Container from '../common/container';

export default function OurStory() {
  return (
    <section className="py-20 bg-white">
      <Container>
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Story</h2>
            <div className="space-y-4 text-gray-600">
              <p>
                WymBee began in 2022 as a deadstock redistribution company, helping businesses manage excess inventory and reduce waste. Through this experience, we identified a critical gap in developing markets: while traditional digitization remained prohibitively expensive for most businesses, messaging apps had achieved 80%+ penetration rates across these same regions.
              </p>
              <p>
                This paradox inspired our pivot in 2025, when we launched our conversational commerce platform that transforms WhatsApp and Telegram into comprehensive business tools without requiring expensive custom development.
              </p>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="relative"
          >
            <div className="relative bg-gradient-to-tr from-primary/5 to-primary/10 rounded-2xl p-8 md:p-10">
              <h3 className="text-2xl font-bold mb-4">Our Mission</h3>
              <p className="text-gray-600">
                To democratize digital transformation by enabling businesses to connect with customers through the messaging platforms they already use and trust.
              </p>
              
              {/* Decorative elements */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-primary/5 rounded-full -translate-x-6 -translate-y-6 blur-xl"></div>
              <div className="absolute bottom-0 left-0 w-16 h-16 bg-primary/10 rounded-full translate-x-4 translate-y-4 blur-lg"></div>
            </div>
            
            {/* Timeline dots */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gray-100 -translate-x-6 hidden md:block">
              <div className="absolute top-0 w-3 h-3 bg-primary rounded-full -translate-x-1"></div>
              <div className="absolute top-1/2 w-3 h-3 bg-primary rounded-full -translate-x-1"></div>
              <div className="absolute bottom-0 w-3 h-3 bg-primary rounded-full -translate-x-1"></div>
            </div>
          </motion.div>
        </div>
      </Container>
    </section>
  );
}